// Swapick App
angular.module('swapick',
  [
    'ionic',
    'angular-storage',
    'swapick.networkconfig',
    'restangular',
    'swapick.satellizer',
    'swapick.permissions',
    'swapick.constants',
    'swapick.states',
    'ionic-pullup',
    'initial-loader',
    'ngCordova',
    'notify',
    'ion-autocomplete',
    'ngOpenFB'
  ])

.run(function($ionicPlatform, Entities, $timeout, $cordovaSplashscreen,
    notifyManager, NotificationStore, Purchase, $openFB) {

  $ionicPlatform.ready(function() {
    // Hide the accessory bar by default (remove this to show the accessory bar above the keyboard
    // for form inputs)
    if (window.cordova && window.cordova.plugins.Keyboard) {
      cordova.plugins.Keyboard.hideKeyboardAccessoryBar(false);
      cordova.plugins.Keyboard.disableScroll(true);

    }
    if (window.StatusBar) {
      // org.apache.cordova.statusbar required
      //StatusBar.styleDefault();
      StatusBar.styleLightContent();
    }
    if(window.cordova){
      $timeout(function(){
          $cordovaSplashscreen.hide();
      }, 500);
      if(cordova.InAppBrowser){
        window.open = cordova.InAppBrowser.open;
      }
    }


    //push notifications
    if(window.PushNotification && false){
      let pusher = PushNotification.init({
        android : {
          senderID : '429335492567'
        },
        ios : {}
      })

      pusher.on('registration', (data)=>{
        console.info("registration", data);
      })

      pusher.on('notification', function(data) {
        console.log("received notification!", data);
        NotificationStore.saveNotification(data);
        if(data.additionalData.foreground){
          //just show the message
          notifyManager.notification(data.message);
        } else {
          //check if we should  switch url
        }
      });
    }

    //facebook
    $openFB.init( {appId: '156101571514110'} );


    if(window.FCMPlugin){
      FCMPlugin.getToken(
        function(token){
          NotificationStore.setDeviceToken(token);
        },
        function(err){
          console.log('error retrieving token: ' + err);
        }
      );

      FCMPlugin.onNotification(
        function(data){
          return;
          if(data.wasTapped){
            //Notification was received on device tray and tapped by the user.
            //alert( JSON.stringify(data) );
            console.log("ntapped", data);
          } else{
            //Notification was received in foreground. Maybe the user needs to be notified.
            //alert( JSON.stringify(data) );
            console.log("n", data)
            notifyManager.notification(data.title, data.body);
          }
        },
        function(msg){
          console.log('onNotification callback successfully registered: ' + msg);
        },
        function(err){
          console.log('Error registering onNotification callback: ' + err);
        }
      );




    }


    Entities.bootstrap();


  });
})

.config(function($ionicConfigProvider, $logProvider, $compileProvider, $animateProvider) {

  $ionicConfigProvider.backButton.previousTitleText(false);
  $ionicConfigProvider.backButton.text('');

  //production config
  if(window.cordova){
    //$ionicConfigProvider.scrolling.jsScrolling(false);
    $logProvider.debugEnabled(false);
    $compileProvider.debugInfoEnabled(false);
    $animateProvider.classNameFilter( /\banimated\b/ );
    $ionicConfigProvider.views.maxCache(5);
  }



});



// WEBPACK FOOTER //
// ./src/app.js